import React from 'react';
import { Box, useTheme } from '@mui/material';
import { SnippetsMain } from '../components';

function CreateSnippet() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  return (
    <Box sx={{ 
      width: '100%',
      minHeight: '100vh',
      backgroundColor: isDark ? '#0F172A' : theme.palette.background.default,
      overflow: 'auto',
      p: 1.5 // Add same padding as docs page
    }} data-page="create">
      <SnippetsMain />
    </Box>
  );
}

export default CreateSnippet;
